import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

// Session lives in an httpOnly cookie; the token is also kept in memory only (never localStorage).
let memoryToken = null;
try { localStorage.removeItem("nexra_token"); } catch { /* storage unavailable */ }

export function getToken() {
  return memoryToken;
}

export function setToken(token) {
  memoryToken = token || null;
}

export function authHeaders() {
  return memoryToken ? { Authorization: `Bearer ${memoryToken}` } : {};
}

export function withAuthParam(url) {
  if (!memoryToken) return url;
  return `${url}${url.includes("?") ? "&" : "?"}auth=${encodeURIComponent(memoryToken)}`;
}

const PUBLIC_ADMIN_PATHS = ["/admin/login", "/admin/forgot-password", "/admin/reset-password"];

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && !PUBLIC_ADMIN_PATHS.includes(path)) {
        setToken(null);
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) {
    const status = err?.response?.status;
    if (status) {
      console.error("API request blocked/failed", { status, url: err?.config?.url, body: err?.response?.data });
    }
    if (status === 403) return "Your submission was blocked by a network security check (403). Please try again, or email us your CV directly.";
    if (status === 413) return "The upload is too large. Please attach a smaller CV (max 10MB).";
    return err?.message || "Something went wrong";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  return String(detail);
}
